// extracted by mini-css-extract-plugin
module.exports = {"number__container":"Number_number__container__3-WUv","number__input":"Number_number__input__17g3r","title":"Number_title__2ezmy","container":"Number_container__69d9Z"};